module.exports = __webpack_public_path__ + "static/media/favourite-full.7d311d28.svg";